/**************************************************
 * Nombre:       Camino
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import punto from "../../../../Recursos/punto.svg";
import ic_cafe from "../../../../Recursos/ic_cafe.svg";
import ic_contrato from "../../../../Recursos/ic_contrato.svg";
import ic_contenedor from "../../../../Recursos/ic_contenedor.svg";
import ic_tienda from "../../../../Recursos/ic_tienda.svg";
import flecha from "../../../../Recursos/flecha.svg";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Camino = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography>
                                <span>
                                   <img src={punto} width={12} height={12} style={{paddingRight: 8}}/>
                                </span>
                    Varietales
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: sCell ? 28 : 32, fontWeight: 700}}>Del Origen a tu Taza</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    {items.map((item, i) => (
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 2.5}}
                        >

                            <Grid container size={{xs: 2, sm: 2, md: 2}} sx={{justifyContent: 'flex-start', mt: 1.5}}>
                                <img src={item.img} width={'auto'} height={42}/>
                            </Grid>

                            <Grid container size={{xs: 10, sm: 10, md: 8}} sx={{justifyContent: 'flex-start',}}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{
                                            fontSize: 24,
                                            fontWeight: 600,
                                            lineHeight: 1.1
                                        }}>{item.nombre}</Typography>
                                    </Grid>


                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 1}}>
                                        <Typography sx={{
                                            fontSize: 16,
                                            fontWeight: 400,
                                            lineHeight: 1.2
                                        }}>{item.descripcion}</Typography>
                                    </Grid>

                                </Grid>
                            </Grid>

                            {i < items.length - 1 &&
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', pl: 1.5, mt: 3}}>
                                    <img src={flecha} height={ sCell ? 50 :70} width={'auto'}/>
                                </Grid>
                            }

                        </Grid>
                    ))}

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Camino

const items = [
    {
        nombre: "Selección de origen",
        descripcion: "Lo haces des la pagina web",
        img: ic_cafe

    },
    {
        nombre: "Negociación y contrato",
        descripcion: "Departamento de venta y comprador",
        img: ic_contrato
    }, {
        nombre: "Logística y transporte",
        descripcion: "Ayudamos al cliente a hacerlo",
        img: ic_contenedor
    },
    {
        nombre: "Llegada a puerto destino",
        descripcion: "Llega hasta donde estas tu",
        img: ic_tienda
    },
]